export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50, 100, 1000];

export const DEFAULT_PAGE_SIZE = 20;

/** Normalize API list response (array legacy or paginated object). */
export function unwrapPaginated(data) {
  if (Array.isArray(data)) {
    return { items: data, total: data.length, page: 1, limit: data.length || DEFAULT_PAGE_SIZE, pages: 1 };
  }
  return {
    items: data?.items ?? data?.rows ?? [],
    total: data?.total ?? data?.count ?? 0,
    page: data?.page ?? 1,
    limit: data?.limit ?? DEFAULT_PAGE_SIZE,
    pages: data?.pages ?? 1,
  };
}
